const { __ } = wp.i18n;
const { InspectorControls, InnerBlocks, MediaPlaceholder, TextAlignmentControl, MediaUpload, MediaUploadCheck } = wp.blockEditor;
const { useState, useEffect, Fragment, useRef } = wp.element;
const { useSelect } = wp.data;
const { TextareaControl, PanelBody, CodeEditor, Card, CardMedia, CardFooter, __experimentalInputControl, __experimentalInputControlSuffixWrapper, __experimentalHeading, TextControl, Button, __experimentalToggleGroupControl, __experimentalBorderBoxControl, Icon, SelectControl, __experimentalToggleGroupControlOptionIcon, __experimentalDivider, BaseControl, Flex, FlexBlock, TabPanel } = wp.components;
import { useBlockProps } from '@wordpress/block-editor';
import DimensionsControl from '../../controls/dimensions/dimensions.js';
import { debounce } from 'lodash';
import ShortUniqueId from 'short-unique-id';
import { alignCenter, alignJustify, alignLeft, alignRight, image, cancelCircleFilled } from '@wordpress/icons';
import { attributes } from '../attributes.js';
import { generateCSS, getCssCustomBlock, addAttributeResponsive, getCustomAttribute, replaceBackgroundImage } from '../functions.js';
import ColorSelector from '../../controls/color-select/color-select.js';
import BorderControl from '../../controls/border/border.js';
import TypographyControl from '../../controls/typography/typography.js';
import BacgroundControl from '../../controls/background/background.js';
import DisplayControl from '../../controls/display/display.js';
import CssCustom from '../../controls/css-custom/css-custom.js';
import SizingControl from '../../controls/sizing/sizing.js';
import CustomAttributeControl from '../../controls/custom-attribute/custom-attribute.js';
import DynamicDropdown from '../../controls/dynamic/dropdown/dropdown.js';
import './image.css';

wp.blocks.registerBlockType('softlite-io-integration/image', {
    apiVersion: 3,
    title: __('Image'),
    icon: image,
    category: 'softlite-io-integration',
    attributes: addAttributeResponsive(attributes),
    edit: (props) => {
        const { attributes, setAttributes } = props;
        const [css, setCss] = useState('');
        const generateID = new ShortUniqueId({ length: 8, dictionary: 'alphanum_lower' });
        const { id, custom_attributes } = attributes;
        const generateNumber = new ShortUniqueId({ length: 4, dictionary: 'number' })
        const [imageSrc, setImageSrc] = useState(attributes?.image?.src ? (!attributes?.image?.src.includes('http') && !attributes?.image?.src.includes('data:image') ? softliteData.site_url + attributes?.image?.src : attributes?.image?.src) : '');
        const [imageWidth, setImageWidth] = useState(attributes?.image?.width ? attributes?.image?.width : 'auto');
        const [imageHeight, setImageHeight] = useState(attributes?.image?.height ? attributes?.image?.height : 'auto');
        const [captionWidth, setCaptionWidth] = useState(attributes?.image?.width ? attributes?.image?.width : '');
        const [attributeCustom, setAttributeCustom] = useState({});
        const [getDynamic, setGetDynamic] = useState(true);
        const [isShortcodeURL, setIsShortcodeURL] = useState(false);
        const openTab = attributes?.state?.openTab ?? 'setting';
        const openSettingSection = attributes?.state?.openSettingSection ?? 'settings';
        const openStyleSection = attributes?.state?.openStyleSection ?? 'layout';

        const currentDevice = useSelect((select) => {
            return select('core/edit-post').__experimentalGetPreviewDeviceType();
        }, []);
        const device = currentDevice.toLowerCase();
        const deviceString = device === 'desktop' ? '' : `:${device}`;

        useEffect(() => {
            if (!id) {
                setAttributes({ id: generateID.rnd() });
            }
            const newCss = generateCSS(attributes, `softlite-block-${attributes.id}`);
            let cssCustomString = getCssCustomBlock(attributes);
            setAttributes({ css: newCss });
            setCss(replaceBackgroundImage(cssCustomString + newCss, softliteData.site_url));
            setAttributeCustom(getCustomAttribute(custom_attributes));
        }, [attributes]);

        useEffect(() => {
            if (isShortcodeURL) {
                handleGetImageShortcode();
                setIsShortcodeURL(false);
            }
        }, [getDynamic]);

        const handleGetImageShortcode = () => {
            fetch(softliteData.ajaxurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: new URLSearchParams({
                    action: 'softlite_dynamic_image',
                    shortcode: attributes?.image?.dynamic_src,
                    post_id: softliteData.postID,
                    post_type: softliteData.post_type
                })
            })
                .then(response => response.text())
                .then(src => {
                    setAttributes({
                        image: {
                            ...attributes.image,
                            id: generateNumber.rnd(),
                            src: src,
                            alt: attributes.image?.alt || ''
                        }
                    });
                    setImageSrc(src || '');
                })
                .catch(error => {
                    console.error('Error fetching shortcode data:', error);
                });
        }

        const handleToggle = (name, type) => {
            setAttributes({state: {...attributes?.state, [type]: name === attributes?.state?.[type] ? '' : name}});
        };

        const handleSelectImageUrl = (url) => {
            setAttributes({
                image: {
                    ...attributes.image,
                    src: url,
                    alt: attributes.image?.alt || ''
                }
            });
            setImageSrc(url);
        }

        const handleSelectImage = (image) => {
            setAttributes({
                image: {
                    ...attributes.image,
                    id: image.id,
                    src: image.url,
                    alt: attributes.image?.alt || image.alt || '', // Chưa có image alt
                    dynamic_src: ''
                }
            });
            setImageSrc(image.url);
        }
        function debounce(func, delay) {
            let debounceTimer;
            return function (...args) {
                const context = this;
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(() => func.apply(context, args), delay);
            };
        }
        const handleChangeImageURL = debounce((url, dynamic) => {
            const shortcodePattern = /\{.*?\}/;
            const isShortcode = shortcodePattern.test(url);
            url = dynamic ? (attributes?.image?.dynamic_src ?? "") + url : url;
            if (isShortcode) {
                setAttributes({ image: { ...attributes?.image, dynamic_src: url, src: '' } });
                setGetDynamic(!getDynamic);
                setIsShortcodeURL(true);
            } else {
                setAttributes({ image: { ...attributes?.image, dynamic_src: '', src: url } });
                setImageSrc(url);
            }
        }, 500)

        const handleChangeImageSize = (newSize, attr) => {
            setAttributes({
                image: {
                    ...attributes.image,
                    [attr]: newSize
                }
            });
            if (attr == 'width') {
                setImageWidth(newSize);
            } else {
                setImageHeight(newSize);
            }
            if (['px', '%', 'em', 'rem', 'vw', 'vh'].includes(newSize.toLowerCase().replace(/[0-9]/g, ''))) {
                setCaptionWidth(newSize);
            } else {
                setCaptionWidth(newSize + 'px');
            }
        }

        const handleChangeCaptionAlignment = (newValue) => {
            setAttributes({
                image: {
                    ...attributes.image,
                    ['caption-alignment']: {
                        ...attributes?.image?.['caption-alignment'],
                        [device]: newValue,
                    },
                },
            });
        }

        const handleRemoveImage = () => {
            setImageSrc('');
            setAttributes({
                image: {
                    ...attributes.image,
                    id: image.id,
                    src: '',
                    alt: attributes.image?.alt || image.alt || '',
                    dynamic_src: ''
                }
            });
        }

        const handleSelectShortcode = (shortcode, oldValue, parameter) => {
            const updatedContent = (oldValue ?? "") + shortcode;
            handleChangeImageAttribute(parameter, updatedContent);
        };

        const handleChangeImageAttribute = (name, newValue) => {
            setAttributes({ image: { ...attributes.image, [name]: newValue } });
        }

        const advancedClassNames = attributes.className ? ' ' + attributes.className : '';

        const blockProps = useBlockProps({
            className: 'softlite-block-image' + advancedClassNames,
        });

        return (
            <>
                {!imageSrc && (
                    <Fragment>
                        <MediaPlaceholder
                            allowedTypes={['image']}
                            onSelectURL={(url) => { handleSelectImageUrl(url) }}
                            onSelect={(imageData) => { handleSelectImage(imageData) }}
                            multiple={false}
                            labels={{ title: 'The Image' }}
                        >
                        </MediaPlaceholder>
                    </Fragment>
                )}

                <InspectorControls>
                    <TabPanel
                        className="softlite-tab-panel"
                        activeClass="active-tab"
                        onSelect={(newTab) => setAttributes({state: {...attributes?.state, openTab: newTab}})}
                        initialTabName={openTab}
                        tabs={[
                            {
                                name: 'setting',
                                title: 'Setting',
                                className: 'softlite-tab-setting',
                            },
                            {
                                name: 'style',
                                title: 'Style',
                                className: 'softlite-tab-style',
                            },
                        ]}
                    >
                        {(tab) => <div>
                            {openTab == 'setting' && (
                                <PanelBody title={__('Settings')} opened={openSettingSection === 'settings'} onToggle={() => handleToggle('settings', 'openSettingSection')}>
                                    <Card style={{ marginBottom: '25px' }}>
                                        {imageSrc && (
                                            <Button className="softlite-button-remove-image" icon={<Icon icon={cancelCircleFilled} size={14} />} onClick={() => { handleRemoveImage() }}></Button>
                                        )}
                                        <CardMedia
                                            style={{ height: '130px' }}
                                        >
                                            <img src={imageSrc} />
                                        </CardMedia>
                                        <CardFooter className="softlite-footer-card-media">
                                            <MediaUploadCheck>
                                                <MediaUpload
                                                    onSelect={(media) => handleSelectImage(media)}
                                                    allowedTypes={'image'}
                                                    //value={mediaId}
                                                    render={({ open }) => (
                                                        <Button onClick={open}>Change Image</Button>
                                                    )}
                                                />
                                            </MediaUploadCheck>
                                        </CardFooter>
                                    </Card>
                                    <__experimentalInputControl
                                        label="URL"
                                        onChange={(newValue) => handleChangeImageURL(newValue, false)}
                                        value={attributes?.['image']?.dynamic_src ? attributes?.['image']?.dynamic_src : attributes?.['image']?.src}
                                        className="softlite-dynamic-url"
                                        suffix={
                                            <__experimentalInputControlSuffixWrapper variant="icon" style={{ 'padding-right': '0px' }}>
                                                <DynamicDropdown
                                                    onSelect={(shortcode) => handleChangeImageURL(shortcode, true)}
                                                    dynamicImage={true}
                                                />
                                            </__experimentalInputControlSuffixWrapper>}
                                    />
                                    <TextControl
                                        label="Width"
                                        value={attributes?.image?.width}
                                        onChange={(newWidth) => handleChangeImageSize(newWidth, 'width')}
                                        className="softlite-image-size"
                                    />
                                    <TextControl
                                        label="Height"
                                        value={attributes?.image?.height}
                                        onChange={(newHeight) => handleChangeImageSize(newHeight, 'height')}
                                        className="softlite-image-size"
                                    />

                                    <__experimentalInputControl
                                        label="Alt Text"
                                        onChange={(newValue) => handleChangeImageAttribute('alt', newValue)}
                                        value={attributes?.['image']?.alt}
                                        className="softlite-dynamic-inline"
                                        suffix={
                                            <__experimentalInputControlSuffixWrapper variant="icon" style={{ 'padding-right': '0px' }}>
                                                <DynamicDropdown onSelect={(shortcode) => handleSelectShortcode(shortcode, attributes?.image?.alt, 'alt')} />
                                            </__experimentalInputControlSuffixWrapper>}
                                    />

                                    <__experimentalInputControl
                                        label="Title"
                                        onChange={(newValue) => handleChangeImageAttribute('title', newValue)}
                                        value={attributes?.['image']?.title}
                                        className="softlite-dynamic-inline"
                                        suffix={
                                            <__experimentalInputControlSuffixWrapper variant="icon" style={{ 'padding-right': '0px' }}>
                                                <DynamicDropdown onSelect={(shortcode) => handleSelectShortcode(shortcode, attributes?.image?.title, 'title')} />
                                            </__experimentalInputControlSuffixWrapper>}
                                    />

                                    <__experimentalInputControl // Chưa làm css cho Caption
                                        label="Caption"
                                        onChange={(newValue) => handleChangeImageAttribute('caption', newValue)}
                                        value={attributes?.['image']?.caption}
                                        className="softlite-dynamic-inline"
                                        suffix={
                                            <__experimentalInputControlSuffixWrapper variant="icon" style={{ 'padding-right': '0px' }}>
                                                <DynamicDropdown onSelect={(shortcode) => handleSelectShortcode(shortcode, attributes?.image?.caption, 'caption')} />
                                            </__experimentalInputControlSuffixWrapper>}
                                    />
                                </PanelBody>
                            )}
                            {openTab == 'style' && (
                                <>
                                    <PanelBody title={__('Layout')} opened={openStyleSection === 'layout'} onToggle={() => handleToggle('layout', 'openStyleSection')} >
                                        <__experimentalHeading>SPACING</__experimentalHeading>
                                        <label>Padding</label>
                                        <DimensionsControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                            attributeName="padding"
                                        />
                                        <__experimentalDivider />
                                        <label>Margin</label>
                                        <DimensionsControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                            attributeName="margin"
                                        />
                                        <__experimentalDivider />
                                        <SizingControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Typography')} opened={openStyleSection === 'typography'} onToggle={() => handleToggle('typography', 'openStyleSection')}>
                                        <TypographyControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Background')} opened={openStyleSection === 'background'} onToggle={() => handleToggle('background', 'openStyleSection')}>
                                        <BacgroundControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Border')} opened={openStyleSection === 'border'} onToggle={() => handleToggle('border', 'openStyleSection')}>
                                        <BorderControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Caption')} opened={openStyleSection === 'caption'} onToggle={() => handleToggle('caption', 'openStyleSection')}>
                                        <__experimentalToggleGroupControl
                                            __nextHasNoMarginBottom
                                            isBlock
                                            isDeselectable={true}
                                            onChange={(newValue) => handleChangeCaptionAlignment(newValue)}
                                            value={attributes?.image?.['caption-alignment']?.[device]}
                                            className={`softlite-typography-toggle-control`}
                                        >
                                            <__experimentalToggleGroupControlOptionIcon
                                                icon={<Icon icon={alignLeft} size={18} />}
                                                label="Left"
                                                value="left"
                                                className={`softlite-typography-toggle-control-option`}
                                            />
                                            <__experimentalToggleGroupControlOptionIcon
                                                icon={<Icon icon={alignCenter} size={18} />}
                                                label="Center"
                                                value="center"
                                                className={`softlite-typography-toggle-control-option`}
                                            />
                                            <__experimentalToggleGroupControlOptionIcon
                                                icon={<Icon icon={alignRight} size={18} />}
                                                label="Right"
                                                value="right"
                                                className={`softlite-typography-toggle-control-option`}
                                            />
                                            <__experimentalToggleGroupControlOptionIcon
                                                icon={<Icon icon={alignJustify} size={18} />}
                                                label="Justify"
                                                value="justify"
                                            />
                                        </__experimentalToggleGroupControl>
                                    </PanelBody>
                                    <PanelBody title={__('Attributes')} opened={openStyleSection === 'custom-attribute'} onToggle={() => handleToggle('custom-attribute', 'openStyleSection')}>
                                        <CustomAttributeControl
                                            items={custom_attributes}
                                            onChange={(newItems) => setAttributes({ custom_attributes: newItems })}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Custom CSS')} opened={openStyleSection === 'custom-css'} onToggle={() => handleToggle('custom-css', 'openStyleSection')}>
                                        <CssCustom
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                </>
                            )}
                        </div>}
                    </TabPanel>
                </InspectorControls>

                <figure {...blockProps} id={`softlite-block-${attributes.id}`} {...attributeCustom}>
                    <img
                        src={imageSrc}
                        width={imageWidth}
                        height={imageHeight}
                        alt={attributes?.image?.alt}
                        title={attributes?.image?.title}
                    />
                    {attributes?.image?.caption && (
                        <figcaption style={{ textAlign: attributes?.image?.['caption-alignment']?.[device], width: captionWidth }}>{attributes?.image?.caption}</figcaption>
                    )}
                </figure>
                {css && (
                    <style type='text/css'>{css}</style>
                )}
            </>
        );
    },
    save: (props) => {
        const { attributes } = props;
        const advancedClassNames = attributes.className ? ' ' + attributes.className : '';
        const allClassNames = `softlite-block-image${advancedClassNames}`;
        let attributeCustom = getCustomAttribute(attributes?.custom_attributes);

        return (
            <>
                {attributes?.image?.caption && (
                    <figure className={allClassNames} id={`softlite-block-${attributes.id}`} {...attributeCustom}>
                        <img
                            src={attributes?.image?.src}
                            width={attributes?.image?.width}
                            height={attributes?.image?.height}
                            alt={attributes?.image?.alt}
                            title={attributes?.image?.title}
                        />
                        <figcaption>{attributes?.image?.caption}</figcaption>

                    </figure>
                )}
                {!attributes?.image?.caption && (
                    <img
                        className={allClassNames}
                        id={`softlite-block-${attributes.id}`}
                        src={attributes?.image?.src}
                        width={attributes?.image?.width}
                        height={attributes?.image?.height}
                        alt={attributes?.image?.alt}
                        title={attributes?.image?.title}
                        {...attributeCustom}
                    />
                )}
            </>
        )
    },
});